import { render, staticRenderFns } from "./BuyToLetMonthlyRent.vue?vue&type=template&id=64939232"
import script from "./BuyToLetMonthlyRent.vue?vue&type=script&lang=js"
export * from "./BuyToLetMonthlyRent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports